export default {
  dataSetName: 'Materialbedarf',
  head: [
    {
      label: 'Produkt',
      key: 'product',
      col: 4,
    },
    {
      label: 'Artnr',
      key: 'articleNumber',
      col: 2,
    },
    {
      label: 'Hersteller',
      key: 'producer',
      col: 2,
    },
    {
      label: 'Menge',
      key: 'amount',
      col: 2,
    },
    {
      label: 'Preis\n[EUR/EH]',
      key: 'unitPrice',
      col: 2,
      unit: 'EUR',
      hideUnit: true,
    },
    {
      label: 'Gesamt\n[EUR]',
      key: 'totalPrice',
      col: 2,
      unit: 'EUR',
      hideUnit: true,
    },
  ],
}
